import { Button, Css, Icon, Loader, Palette } from "@homebound/beam";
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useApproveTradePartnerAvailabilityRequestMutation, useCurrentUserQuery } from "src/generated/graphql-types";
import { schedulePath } from "../routesDef";

type ConfirmAvailabilityParams = {
  token: string;
};

export function ConfirmAvailabilityPage() {
  const { token } = useParams<ConfirmAvailabilityParams>();
  const [approveRequest, { loading, error, called }] = useApproveTradePartnerAvailabilityRequestMutation();
  const { data: userData } = useCurrentUserQuery();

  useEffect(() => {
    if (token) {
      // React really doesn't like useEffect blowing up in unit tests,
      // so just suppress the error & read it from the hook result
      approveRequest({ variables: { confirmationToken: token } }).catch(() => {});
    }
  }, [token, approveRequest]);

  const confirmed = called && !loading && !error;
  const isAuthenticated = !!userData?.currentUser?.id;

  return (
    <div css={Css.df.fdc.aic.jcfs.vh100.w100.p6.bgGray100.$}>
      <div css={Css.df.fdc.aic.bgWhite.px4.py6.w100.br8.$}>
        {error ? (
          <ErrorState isAuthenticated={isAuthenticated} />
        ) : confirmed ? (
          <ConfirmedState isAuthenticated={isAuthenticated} />
        ) : (
          <LoadingState />
        )}
      </div>
    </div>
  );
}

function LoadingState() {
  return (
    <>
      <Loader />
      <div css={Css.xl2Sb.mt4.tac.$}>Confirming...</div>
    </>
  );
}

function ConfirmedState({ isAuthenticated }: { isAuthenticated: boolean }) {
  return (
    <>
      <div css={Css.mt6.$}>
        <Icon icon="checkCircle" color={Palette.Green500} inc={16} />
      </div>
      <div css={Css.xl2Sb.mt4.tac.$}>Confirmed</div>
      <div css={Css.w100.my4.bb.bcGray200.$} />
      <ScheduleButton isAuthenticated={isAuthenticated} />
      <div css={Css.tac.mt6.$}>
        <div css={Css.smSb.$}>Questions?</div>
        <div css={Css.sm.$}>Contact your Homebound contact for help.</div>
      </div>
    </>
  );
}

function ErrorState({ isAuthenticated }: { isAuthenticated: boolean }) {
  return (
    <>
      <Icon icon="errorCircle" color={Palette.Red500} inc={16} />
      <div css={Css.xl2Sb.mt4.tac.$}>Sorry, Something Went Wrong</div>
      <div css={Css.sm.gray700.tac.mt2.$}>
        Your confirmation cannot be completed. Please reach out to your Homebound contact for help.
      </div>
      <div css={Css.w100.my4.bb.bcGray200.$} />
      <ScheduleButton isAuthenticated={isAuthenticated} />
    </>
  );
}

function ScheduleButton({ isAuthenticated }: { isAuthenticated: boolean }) {
  if (isAuthenticated) {
    return (
      <Link to={schedulePath}>
        <Button label="View your schedule" size="lg" onClick={() => {}} />
      </Link>
    );
  }
  return (
    <Link to="/login">
      <Button label="Sign in to view your schedule" size="lg" onClick={() => {}} />
    </Link>
  );
}
